import styles from "./CenterCard.module.css";

interface Center {
    name: string;
}

interface CenterCardProps {
    centers: Center[];
    onSelect?: (centerName: string) => void;
}

export const CenterCard = ({ centers, onSelect }: CenterCardProps) => {
    if (!centers || centers.length === 0) {
        return (
            <div className={styles.container}>
                <div className={styles.header}>Available Centers</div>
                <div className={styles.empty}>No centers available.</div>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <div className={styles.header}>Available Centers</div>
            <div className={styles.grid}>
                {centers.map((center) => (
                    <button
                        key={center.name}
                        className={styles.card}
                        onClick={() => onSelect?.(center.name)}
                    >
                        <span className={styles.icon}>📍</span>
                        <span className={styles.name}>{center.name}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};
